export default __webpack_public_path__ + "static/media/graph-type-4.55ce33a3.png";